import React, { forwardRef, InputHTMLAttributes } from 'react';
import tw, { TwStyle } from 'twin.macro';
import { motion, AnimatePresence } from 'framer-motion';

const InputWrapper = tw.div`w-full`;
const StyledInput = tw.input`w-full h-full bg-transparent text-sm text-text-and-icon autofill:text-text-and-icon autofill:bg-transparent placeholder:text-text-and-icon-muted focus:text-text-and-icon p-3 border border-gray-1 rounded-md`;
const InputLabel = tw.label`text-sm text-text-and-icon`;
const HelperTextContainer = tw.div`mt-1 text-xs font-normal text-error`;
const AnimatedHelperTextContainer = motion.div;

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelStyle?: TwStyle;
  error?: string;
  inline?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { name, onChange, inline, label, error, labelStyle, ...inputProps } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  return (
    <InputWrapper css={[inline && tw`w-auto inline-block`]}>
      {/* We will add a label to support accessibility even though it is not currently in the design. */}
      {label ? (
        <InputLabel css={[labelStyle && labelStyle]} htmlFor={name}>
          {label}
        </InputLabel>
      ) : null}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <StyledInput
        autoComplete='off'
        ref={ref}
        name={name}
        onChange={(e) => {
          handleChange(e as React.ChangeEvent<HTMLInputElement>);
        }}
        {...inputProps}
      />
      <AnimatePresence mode='wait'>
        <AnimatedHelperTextContainer layout>
          <HelperTextContainer>{error}</HelperTextContainer>
        </AnimatedHelperTextContainer>
      </AnimatePresence>
    </InputWrapper>
  );
});

Input.displayName = 'Input';

export { Input };
